import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DistributionLane } from 'planning-portal-library/src/lib/core/domain';
import { injectEnvironment } from 'planning-portal-library/src/lib/core/environments/environment.token';
import { DistributionLaneRepository } from 'planning-portal-library/src/lib/core/repositories';
import { catchError, map, mergeMap, Observable, reduce } from 'rxjs';
import { BaseRequest } from '../../../shared/base.request';
import { BaseResponse } from '../../../shared/base.response';
import { DistributionLaneApiUrls } from './distribution-lane-api-urls';
import { DistributionLaneWebRepositoryMapper } from './entities/distribution-lane-web-repository-mapper';

@Injectable({ providedIn: 'root' })
export class DistributionLaneWebRepository extends DistributionLaneRepository {
  private readonly distributionLaneWebRepositoryMapper =
    new DistributionLaneWebRepositoryMapper();
  private readonly environment = injectEnvironment();

  constructor(private readonly http: HttpClient) {
    super();
  }

  getDistributionLanes(
    request: BaseRequest<any>
  ): Observable<DistributionLane[]> {
    return this.http
      .get<BaseResponse<DistributionLane[]>>(
        `${this.environment.url}${DistributionLaneApiUrls.GetDistributionLanes}`
      )
      .pipe(
        mergeMap(
          (response: BaseResponse<DistributionLane[]>) => response.result!
        ),
        catchError((error) => {
          throw error;
        })
      )
      .pipe(map(this.distributionLaneWebRepositoryMapper.mapFrom))
      .pipe(
        reduce(
          (items: DistributionLane[], item: DistributionLane) => [
            ...items,
            item,
          ],
          []
        )
      );
  }
}
